import { Box, Flex } from '@chakra-ui/react';
import { DeliveryOrderItem } from '@diamond/shared/types';
import { Text } from '@diamond/shared/ui';

import { OrderItemQuantityMeta } from './types';
import { formatOrderItemQuantity, resolveOrderItemUnit } from './utils';

export interface ProductItemProps {
  item: DeliveryOrderItem;
  quantityMeta?: OrderItemQuantityMeta;
}

/**
 * Displays a single product item within a DO (Delivery Order)
 */
export function ProductItem({ item, quantityMeta }: ProductItemProps) {
  const unitLabel = resolveOrderItemUnit(quantityMeta, item.sales_unit);
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      py={1}
      data-testid="product-item"
    >
      <Box flex={1} minW={0}>
        <Text
          fontSize={{ base: 'xs', md: 'sm' }}
          color="gray.700"
          noOfLines={1}
        >
          {item.product_name}
        </Text>
        <Text as="span" fontSize="10px" color="gray.500">
          <Box as="span" fontSize="12px" color="inherit">
            {formatOrderItemQuantity(item.delivered_quantity, quantityMeta)}
          </Box>
          {' dari '}
          <Box as="span" fontSize="12px" color="inherit">
            {formatOrderItemQuantity(item.ordered_quantity, quantityMeta)}
          </Box>{' '}
          {unitLabel}
        </Text>
      </Box>
    </Flex>
  );
}
